import { useEffect, useRef } from 'react';

// oxlint-disable-next-line no-explicit-any -- any
export const useDebounce = (callback: (...arg: any[]) => void, delay = 300) => {
  // oxlint-disable-next-line no-explicit-any -- any
  const timeoutRef = useRef<any>(undefined);

  useEffect(() => {
    // Cleanup the previous timeout on re-render
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const debouncedCallback = (...args: unknown[]) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      callback(...args);
    }, delay);
  };

  return debouncedCallback;
};
